(ns client-portal.client.voice-insights.shared
  (:require [cljs-time.core :as t]
            [clojure.set :as set]
            [shared.core.components.components :as c]
            [shared.core.components.recharts-components :as recharts.c]
            [shared.core.components.tooltip :as tooltip]
            [shared.core.components.recharts.tooltip :as rc-tooltip]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.router :as router]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [client-portal.client.anonymous.data :as anon.d]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.components.analytics :as cp.c]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [shared.core.util :as util]
            [cljs-time.format :as t.f]
            [shared.core.time :as time]
            [client-portal.client.vi.components.tag :refer [tag->display-name]]))

(style/add-css [".novo-dropdown.ui.search, .novo-dropdown.ui.search.active, .novo-dropdown.ui.search.active:hover, .novo-dropdown.ui.search:hover"
                {:display :flex
                 :align-items :center
                 :border "1px solid rgba(0, 0, 0, 0.2)"
                 :border-radius "3px"}]
               [(str ".novo-dropdown.ui.search.primary.active,"
                     ".novo-dropdown.ui.search.primary.active:hover")
                {:border "1px solid rgba(0, 0, 0, 0.2)"}]
               [".novo-dropdown.ui.search.active .menu"
                {:margin-top "1px"
                 :border :none}]
               [".novo-dropdown.ui.dropdown>.dropdown.icon.clear:before"
                {:color "#000"
                 :font-size "11px"}]
               [".novo-dropdown.ui.search.selection.dropdown>input.search"
                {:padding "8px 20px 8px 5px"
                 :height "100%"}]
               [".novo-dropdown.ui.search.active .menu>.item"
                {:padding "6px 6px 6px 9px !important"}]
               [".novo-dropdown.ui.search.active .menu>.item.selected"
                {:background-color "rgba(0, 0, 0, 0.03)"}]
               [(str ".novo-dropdown.ui.search.active .menu>.item:hover,"
                     ".novo-dropdown.ui.search.active .menu>.item.active:hover")
                {:background-color "rgba(0, 0, 0, 0.03)"}]
               [".novo-dropdown.ui.search.active .menu>.item.active"
                {:background-color "#fff"}]
               [".novo-dropdown.ui.search.active .menu>.item.active.selected"
                {:background-color "rgba(0, 0, 0, 0.03)"}]
               [".novo-dropdown.ui.search.active:not(.multiselect-checkbox-dropdown) .menu>.item.active::after"
                {:content "'check'"
                 :background-color "transparent"
                 :color (style/color :black :base)
                 :font-family "'Material Icons'"
                 :font-size "14px"
                 :position "absolute"
                 :top "50%"
                 :right "6px"
                 :transform "translateY(-50%)"}]
               [".novo-dropdown.ui.search.active .menu>.item>span"
                {:font-family style/roboto-font-family
                 :font-size "12px"
                 :line-height "18px"
                 :font-weight style/font-regular-weight
                 :color (util/hex->rgba (style/color :black :base) 0.8)}]
               [".novo-dropdown.ui.selection.dropdown>.dropdown.icon"
                {:background-color "#fff"
                 :border-radius "2px"
                 :display "flex"
                 :align-items "center"
                 :justify-content "center"
                 :right "0px"
                 :padding "5px 6px"}]
               [".novo-dropdown.ui.selection.dropdown>.dropdown.icon:not(.clear)::before"
                {:font-family "'Material Icons'"
                 :content "'keyboard_arrow_down'"
                 :color (style/color :black :base)
                 :font-size "12px"}]
               [".novo-dropdown.ui.selection.dropdown>.dropdown.icon.clear"
                {:margin-top "0px"}]
               [".novo-dropdown.ui.search.active"
                {:z-index 11}]
               [".novo-dropdown.ui.search.active .menu"
                {:margin-top "1px"
                 :margin-bottom "0px"}]
               [".novo-dropdown.ui.search.active.upward .menu"
                {:margin-top "0px"
                 :margin-bottom "1px"}]
               [".ui.active.selection.dropdown, .ui.simple.active.dropdown, .ui.simple.dropdown:hover"
                {:border-bottom-left-radius "3px !important"
                 :border-bottom-right-radius "3px !important"}]
               [".novo-dropdown.ui.dropdown .menu>.message"
                {:font-size "12px"}])
(def date-formatter-yyyy-MM-dd (t.f/formatter "yyyy-MM-dd"))

(defn format-in-MMM-d [date-str]
  (let [parsed-date (t.f/parse date-formatter-yyyy-MM-dd date-str)]
    (str (t.f/unparse (t.f/formatter "MMM") parsed-date) " " (t/day parsed-date))))

(defn day-parts-radio-buttons
  [{:keys [day-parts selected-day-part on-change]}]
  (when (not-empty day-parts)
    (let [day-parts (->> (sort-by :start-time day-parts)
                         (into [vi.d/day-part-all-day]))
          label->day-part (into {} (map (juxt :label identity)) day-parts)
          some-selected? (some #(= (:label %) selected-day-part) day-parts)
          value (if some-selected?
                  selected-day-part
                  (:label vi.d/day-part-all-day))
          time-range (fn [{:keys [start-time end-time]}]
                       (when (and start-time end-time)
                         (str (time/reformat-date-str start-time "h:mm A")
                              " - "
                              (time/reformat-date-str end-time "h:mm A"))))
          select! (fn [v]
                    (when (and on-change (seq v))
                      (on-change (label->day-part v))))]
      (if @(re/subscribe [:core/mobile-layout?-])
        [alc/up-dropdown {:value value
                          :on-change select!
                          :options (mapv (fn [{:keys [label] :as day-part}]
                                           {:value label
                                            :text (str (util/capitalize-words label)
                                                       (some->> (time-range day-part) (str " · ")))})
                                         day-parts)}]
        [alc/up-toggle-group {:type "single"
                              :value value
                              :on-value-change select!
                              :items (mapv (fn [{:keys [label] :as day-part}]
                                             {:value label
                                              :content [:div {:style {:display :flex
                                                                      :align-items :center
                                                                      :gap 4}}
                                                        [:span (util/capitalize-words label)]
                                                        (when-let [range-text (time-range day-part)]
                                                          [:span {:style {:color (style/alc-color "Text/secondary")
                                                                          :font-size 10}}
                                                           range-text])]})
                                           day-parts)}]))))

(defn fill-missing-start-values [scores-over-time date-range]
  (let [query-params @(re/subscribe [:router/current-query-params-])
        selected-date (:date query-params)
        end-date (if selected-date
                   (t.f/parse date-formatter-yyyy-MM-dd selected-date)
                   (t/now))
        start-date-in-data (if (seq scores-over-time)
                             (t.f/parse date-formatter-yyyy-MM-dd (:date (first scores-over-time)))
                             end-date)
        start-date (t/minus end-date (t/days (if selected-date 7 date-range)))]
    (if (t/before? start-date start-date-in-data)
      (let [missing-days (t/in-days (t/interval start-date start-date-in-data))]
        (concat (map (fn [i]
                       (let [cur-date (t/plus start-date (t/days i))]
                         {:date (t.f/unparse date-formatter-yyyy-MM-dd cur-date)
                          :score nil}))
                     (range missing-days))
                scores-over-time))
      scores-over-time)))

(defn non-empty-or
  [value default]
  (if (or (nil? value) (and (coll? value) (empty? value)) (= value 0) (= value ""))
    default
    value))

(defn get-color-for-header-value
  [value]
  (if (or (nil? value) (= value 0) (= value ""))
    (style/alc-color "Text/secondary")
    (style/alc-color "Text/primary")))

(defn data-loading? [d]
  (or (util/loading? d) (nil? d)))

(defn header-analytics [_]
  (let [crew-name- (re/subscribe [:voice-insights/crew-name-])]
    (fn [{:keys [conversations-count
                 conversations-duration
                 conversations-duration-over-time
                 crew-utterances-count
                 customer-utterances-count
                 crew-utterances-count-over-time
                 customer-utterances-count-over-time
                 style]}]
      (if (or (data-loading? conversations-count)
              (data-loading? conversations-duration)
              (data-loading? conversations-duration-over-time)
              (data-loading? crew-utterances-count)
              (data-loading? customer-utterances-count)
              (data-loading? crew-utterances-count-over-time)
              (data-loading? customer-utterances-count-over-time))
        [c/loader-rectangle {:height 83
                             :style (merge {:margin-top 24} style)}]
        [:div {:class-name style/grid-2-on-mobile-class-name
               :style (merge {:border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                              :border-radius "12px"
                              :display :flex
                              :margin-top 24}
                             style)}
         [cp.c/header-with-content {:title "Total Conversations"
                                    :icon-type :forum}
          [:span {:style {:font-size 16
                          :line-height "30px"
                          :font-weight style/font-semi-bold-weight
                          :color (get-color-for-header-value conversations-count)}}
           (non-empty-or (or (when (= conversations-count 0) "")
                             (when (integer? conversations-count) (util/readable-number conversations-count))
                             conversations-count)
                         "N/A")]]
         [cp.c/header-with-content {:title "Avg Duration"
                                    :icon-type :access-time-filled}
          [:div {:style {:display :flex
                         :gap 12}}
           [:span {:style {:font-size 16
                           :line-height "30px"
                           :font-weight style/font-semi-bold-weight
                           :color (get-color-for-header-value conversations-duration)}}
            (non-empty-or conversations-duration "N/A")]
           [cp.c/header-line-chart {:data (->> (vi.d/sort-by-date :dt conversations-duration-over-time)
                                          (map-indexed (fn [i y]
                                                         {:x i
                                                          :y (util/to-precision (:average-duration y))})))}]]]
         [cp.c/header-with-content {:title (str "Avg " @crew-name- " Utterances")
                                    :icon-type :headset-mic}
          [:div {:style {:display :flex
                         :gap 12}}
           [:span {:style {:font-size 16
                           :line-height "30px"
                           :font-weight style/font-semi-bold-weight
                           :color (get-color-for-header-value crew-utterances-count)}}
            (non-empty-or crew-utterances-count "N/A")]
           [cp.c/header-line-chart {:data (->> (sort-by #(t.f/parse vi.d/date-formatter (:dt %))
                                                   t/before?
                                                   crew-utterances-count-over-time)
                                          (map-indexed (fn [i y]
                                                         {:x i
                                                          :y (util/to-precision (:average-utterances y))})))}]]]
         [cp.c/header-with-content {:title "Avg Customer Utterances"
                                    :icon-type :record-voice-over}

          [:div {:style {:display :flex
                         :gap 12}}
           [:span {:style {:font-size 16
                           :line-height "30px"
                           :font-weight style/font-semi-bold-weight
                           :color (get-color-for-header-value customer-utterances-count)}}
            (non-empty-or customer-utterances-count "N/A")]
           [cp.c/header-line-chart {:data (->> (sort-by #(t.f/parse vi.d/date-formatter (:dt %))
                                                   t/before?
                                                   customer-utterances-count-over-time)
                                          (map-indexed (fn [i y]
                                                         {:x i
                                                          :y (util/to-precision (:average-utterances y))})))}]]]]))))


(defn concept-category-scores [_]
  (let [locations- (re/subscribe [:locations/by-current-concept-id-])
        timeframe- (re/subscribe [:voice-insights/timeframe-])]
    (fn [{:keys [category category-label gauge-config icon-type score avg-score scores-over-time color bg-color]}]
      (let [sorted-scores-over-time (if (util/loading? scores-over-time)
                                      :loading
                                      (vi.d/sort-by-date :date scores-over-time))
            difference (if (util/loading? sorted-scores-over-time)
                         0
                         (let [scores (map #(-> % :score util/parse-float) sorted-scores-over-time)
                               first-score (first scores)
                               last-score (last scores)]
                           (if last-score
                             (- last-score (or first-score 0))
                             0)))
            score? (not (nil? score))
            score-diff (when score?
                         (some-> difference
                                 (js/Math.round)
                                 (js/Math.abs)))
            subtitle (when-not (nil? score)
                       (str score-diff
                            (condp = @timeframe-
                              "most-recent" " over Most Recent time period"
                              0 " Today"
                              1 " Yesterday"
                              -1 " over Selected Dates"
                              (str " over last " @timeframe- " days"))))
            subtitle-icon-color (when-not (nil? score)
                                  (if (>= difference 0)
                                    (style/color :green :shade-8)
                                    (style/color :red :shade-6)))
            category-label (or category-label (util/capitalize-words category))]
        (if (or (util/loading? score)
                (util/loading? avg-score)
                (util/loading? sorted-scores-over-time))
          [c/loader-rectangle {:style {:flex 1
                                       :height 340
                                       :min-height 340
                                       :style {:box-shadow "-20px 9px 4px 2px rgba(0, 0, 0, 0.01)"}}}]
          (let [area-data (map (fn [score-by-date]
                                 {:x (format-in-MMM-d (:date score-by-date))
                                  :y (min (:score score-by-date) 100)})
                               sorted-scores-over-time
                               #_(fill-missing-start-values sorted-scores-over-time (max 7 @timeframe-)))
                avg-score? (and (util/not-loading? avg-score)
                                (some-> avg-score (pos?))
                                (some-> (util/when-not-loading @locations-)
                                        (count)
                                        (> 1)))
                need-y-max? (and avg-score? (some #(> avg-score (:y %)) area-data))
                subtitle-icon (if (>= difference 0) :expand-less :expand-more)]
            [alc/card {:title category-label
                       :material-icon-type icon-type
                       :color color
                       :style {:flex 1
                               :padding "16px 0px 26px"}
                       :header-style {:padding "0 16px"}}
             [:div {:style {:display :flex
                            :flex-direction :column
                            :align-items :center
                            :gap 12
                            :padding "0 12px"}}
              [:div {:style {:position :relative}}
               [recharts.c/gauge-chart (merge {:label category-label
                                               :value score
                                               :stops [25 50 25]
                                               :colors ["#FF8080" "#FEAC2A" "#4AC53F"]
                                               :average (when (util/not-loading? avg-score) avg-score)}
                                              gauge-config)]
               (when subtitle
                 [:div {:style {:display :flex
                                :align-items :center
                                :justify-content :center
                                :position :absolute
                                :bottom 10
                                :left "50%"
                                :transform "translateX(-50%)"
                                :width "100%"}}
                  (when subtitle-icon
                    [alc/material-icon {:icon-type subtitle-icon
                                        :style {:color subtitle-icon-color
                                                :font-size 16}}])
                  (when subtitle
                    [:span {:style {:font-family style/roboto-font-family
                                    :font-size 11
                                    :line-height :normal
                                    :font-weight style/font-medium-weight
                                    :color (style/alc-color "Text/secondary")}}
                     subtitle])])]
              [recharts.c/area-chart (cond-> {:data area-data
                                              :x-key :x
                                              :y-key :y
                                              :average (when avg-score?
                                                         {:value avg-score
                                                          :label (str "All Locations Avg. " avg-score)})
                                              :id category
                                              :color color
                                              :smooth? false
                                              :tooltip-label-fn (fn [] category-label)}
                                             need-y-max?
                                             (assoc :y-domain [0 (min (+ avg-score 5) 100)]))]]]))))))

(defn filter-item
  [{:keys [value on-close]}]
  [:div {:style {:display :flex
                 :padding "3px 12px 3px 9px"
                 :align-items :center
                 :gap 8
                 :border-radius 60
                 :border "1px solid rgba(0, 0, 0, 0.20)"
                 :background-color "rgba(153, 51, 240, 0.20)"}}
   [:span {:style {:font-size 12
                   :line-height "18px"
                   :font-weight style/font-regular-weight
                   :color (style/color :black :base)}}
    value]
   (when on-close
     [c/interactive
      :div {:style {:display :flex
                    :cursor :pointer}
            :on-click on-close}
      [c/material-icon {:icon-type :close
                        :style {:font-size 14
                                :color (style/color :black :base)}}]])])

(defn tag-bar
  [[tag-name tags-details]
   {:keys [selected-part location-metrics?]
    :or {selected-part (:label vi.d/day-part-all-day) location-metrics? false}}]
  (let [all-day-part? (= selected-part (:label vi.d/day-part-all-day))
        tag-details (first (filter #(= (:part %) selected-part) tags-details))
        day-parts-schedules- (when (not location-metrics?) (re/subscribe [:day-parts/by-current-concept-id-]))
        day-part-label->start-time (when (and day-parts-schedules- (util/not-loading? @day-parts-schedules-))
                                     (into {} (map (fn [p] [(str (:label p)) (:start-time p)]) @day-parts-schedules-)))
        other-details (when all-day-part?
                        (->> (filter #(not= (:part %) selected-part) tags-details)
                             (sort-by #(get day-part-label->start-time (:part %)))))
        tag-values (remove #(contains? #{"not-applicable"} (:value %)) (:values tag-details))
        total-count (apply + (map :count tag-values))
        category (or (:category tag-details) "other")
        bar-color-opacities (vi.d/opacity-gradient (count tag-values))
        query-params @(re/subscribe [:router/current-query-params-])
        tag-bar-open-count (re/subscribe [:voice-insights/tag-bar-open-count- tag-name])
        day-part-child-metrics? (and (not all-day-part?) (not location-metrics?))
        day-part-schedule (when (and day-part-child-metrics? (util/not-loading? @day-parts-schedules-))
                            (let [day-part (first (filter #(= (:label %) selected-part) @day-parts-schedules-))]
                              (if day-part
                                (str (time/reformat-date-str (:start-time day-part) "h:mm A")
                                     " - "
                                     (time/reformat-date-str (:end-time day-part) "h:mm A"))
                                "Unknown")))
        location-child-metrics? (and (not all-day-part?) location-metrics?)
        locations- (when location-child-metrics? (re/subscribe [:locations/by-current-concept-id-]))
        location-label (when (and location-child-metrics? (util/not-loading? @locations-))
                         (or (some->> @locations-
                                      (filter #(= (:id %) (util/parse-int selected-part)))
                                      (first)
                                      :label
                                      (anon.d/location-label))
                             "Unknown"))
        other-details? (> (count other-details) 0)
        concept-id @(re/subscribe [:concepts/current-concept-id-])
        mobile? @(re/subscribe [:core/mobile-layout?-])
        text-color (or (vi.d/category-color category :text-color)
                       (style/alc-color "Common/White"))
        pct-color (or (vi.d/category-color category :pct-color)
                      (util/hex->rgba "#fff" 0.8))
        segments (->> (sort-by (fn [{:keys [value]}]
                                 (vi.d/tag-sort-order tag-name value))
                               tag-values)
                      (map-indexed (fn [idx {:keys [value count]}]
                                     (let [pct (* (/ count total-count) 100.0)
                                           color-opacity (nth bar-color-opacities idx)]
                                       {:value-label (tag->display-name {:value value})
                                        :opacity color-opacity
                                        :pct pct
                                        :pct-label (str (if (< pct 1.0)
                                                          "<1"
                                                          (util/to-precision pct :precision 0))
                                                        "%")
                                        :color (util/hex->rgba (vi.d/category-color category :base) color-opacity)
                                        :background (str "linear-gradient(90deg, "
                                                         (util/hex->rgba (vi.d/category-color category :base) color-opacity) " 0%, "
                                                         (util/hex->rgba (vi.d/category-color category :gradient) color-opacity) " 100%")
                                        :first? (= idx 0)
                                        :last? (= idx (dec (clojure.core/count tag-values)))
                                        :session-route [:vi/sessions
                                                        nil
                                                        (cond-> {:cid (or (when (not-empty (:cid query-params))
                                                                            (:cid query-params))
                                                                          (some-> concept-id (str)))
                                                                 :fd (sessions.d/filters->query-param
                                                                       [{:by "tags"
                                                                         :condition "include"
                                                                         :join "or"
                                                                         :value [{:name tag-name
                                                                                  :value value}]}])}

                                                                (not-empty (:ct query-params))
                                                                (assoc :ct (:ct query-params))

                                                                (not-empty (:dsid query-params))
                                                                (assoc :dsid (:dsid query-params))

                                                                (not-empty (:ns query-params))
                                                                (assoc :ns (:ns query-params))

                                                                (not-empty (:tf query-params))
                                                                (assoc :tf (:tf query-params))

                                                                (not-empty (:start query-params))
                                                                (assoc :start (:start query-params))

                                                                (not-empty (:end query-params))
                                                                (assoc :end (:end query-params))

                                                                (and (not location-child-metrics?) (:lid query-params))
                                                                (assoc :lid (:lid query-params))

                                                                (and location-child-metrics? selected-part)
                                                                (assoc :lid selected-part))]}))))
        label-cmp [:span {:style {:flex 1
                                  :font-size 12
                                  :font-weight 400
                                  :line-height 1.33
                                  :color (if location-child-metrics?
                                           (style/alc-color "Text/secondary")
                                           (style/alc-color "Text/primary"))
                                  :text-align (if mobile? :left :right)}}
                   (if all-day-part?
                     (tag->display-name {:name tag-name})
                     (if location-child-metrics?
                       location-label
                       (util/->capitalize-words selected-part)))]
        expand-icon-cmp (when (> (count other-details) 1)
                          [c/material-icon {:icon-type (if (> @tag-bar-open-count 0) :expand_more :chevron_right)
                                            :style {:color (style/alc-color "Text/primary")
                                                    :font-size 12}}])
        schedule-cmp (when day-part-child-metrics?
                       [:span {:style {:color (style/alc-color "Text/secondary")
                                       :font-size 12
                                       :font-weight 400
                                       :line-height 1.33}}
                        day-part-schedule])]
    [:div {:style {:display :flex
                   :flex-direction :column}}
     (if mobile?
       [:div {:style {:display :flex
                      :flex-direction :column
                      :gap 6
                      :padding (if all-day-part? "10px 16px" "6px 16px 6px 28px")}}
        [c/interactive
         :div {:style {:display :flex
                       :align-items :center
                       :gap 6
                       :min-height 20}
               :on-click (when other-details?
                           #(re/dispatch [:voice-insights/toggle-tag-bar-open tag-name]))}
         label-cmp
         schedule-cmp
         expand-icon-cmp]
        (into [:div {:style {:display :flex
                             :flex-wrap :wrap
                             :gap 4}}]
              (map (fn [{:keys [value-label pct-label background opacity session-route]}]
                     (let [dark-text? (and (< opacity 0.6) (nil? (vi.d/category-color category :text-color)))]
                       [:div {:style {:display :flex
                                      :align-items :baseline
                                      :gap 4
                                      :padding "4px 8px"
                                      :border-radius 4
                                      :background background
                                      :cursor :pointer}
                              :on-click #(router/open-route-based-on-event % session-route)}
                        [:span {:style {:font-size 12
                                        :line-height "16px"
                                        :font-weight style/font-medium-weight
                                        :color (if dark-text? (style/alc-color "Text/primary_const") text-color)}}
                         value-label]
                        [:span {:style {:font-size 12
                                        :line-height "16px"
                                        :font-weight style/font-regular-weight
                                        :color (if dark-text? (style/alc-color "Text/secondary") pct-color)}}
                         pct-label]]))
                   segments))]
       [c/interactive
        :div {:style {:display :flex
                      :flex-direction :row
                      :align-items :center
                      :padding (if all-day-part? "8px 24px 8px 16px" "0px 24px 0px 16px")
                      :gap 12}
              :hover-style (when other-details?
                             {:background-color (util/hex->rgba (style/alc-color "Background/page") 0.6)
                              :cursor :pointer})
              :on-click (when other-details?
                          #(re/dispatch [:voice-insights/toggle-tag-bar-open tag-name]))}
        [:div {:style {:width 120
                       :min-height (when-not day-part-child-metrics? 24)
                       :display :flex
                       :flex-direction (when day-part-child-metrics? :column)
                       :align-items :center
                       :gap (when-not day-part-child-metrics? 6)}}
         label-cmp
         expand-icon-cmp
         schedule-cmp]
        (into [:div {:style {:display :flex
                             :width "100%"
                             :height (if all-day-part? "100%" 10)}}]
              (map (fn [{:keys [value-label pct pct-label color background first? last? session-route]}]
                     [tooltip/tooltip
                      {:placement :bottom
                       :arrow? false
                       :theme "transparent"
                       :tooltip-container-style {:padding 0}
                       :style {:display :flex
                               :align-items :center
                               :width (str pct "%")
                               :height "100%"
                               :background background
                               :border-top-left-radius (when first? 3)
                               :border-bottom-left-radius (when first? 3)
                               :border-top-right-radius (when last? 3)
                               :border-bottom-right-radius (when last? 3)}
                       :tooltip-content [rc-tooltip/tooltip-panel
                                         {:numeric-align :right
                                          :rows [{:label value-label
                                                  :percent pct-label
                                                  :indicator {:shape :circle
                                                              :color color}}]
                                          :show-double-click-message? true}]
                       :target-content [:div {:style {:cursor :pointer
                                                      :display :flex
                                                      :align-items :center
                                                      :overflow :hidden
                                                      :width "100%"
                                                      :height "100%"
                                                      :padding "5px 0px 3px 8px"}
                                              :on-double-click #(router/open-route-based-on-event % session-route)}
                                        (when all-day-part?
                                          [:<>
                                           [:span {:style {:flex "0 0 auto"
                                                           :font-size 10
                                                           :line-height "16px"
                                                           :font-weight style/font-medium-weight
                                                           :color text-color}}
                                            value-label]
                                           [:span {:style {:flex "0 0 auto"
                                                           :font-size 10
                                                           :line-height "16px"
                                                           :margin-left 4
                                                           :font-weight style/font-regular-weight
                                                           :color pct-color}}
                                            pct-label]])]}])
                   segments))])
     (when (and all-day-part?
                (> (count other-details) 1)
                (> @tag-bar-open-count 0))
       (into [:div {:style {:display :flex
                            :flex-direction :column
                            :gap 6
                            :padding "6px 0px"
                            :background-color (util/hex->rgba (style/color :black :base) 0.02)
                            :border-bottom (str "1px solid " (util/hex->rgba (style/color :black :base) 0.06))}}]
             [(map (fn [d]
                     [tag-bar
                      [tag-name tags-details]
                      {:selected-part (:part d)
                       :location-metrics? location-metrics?}])
                   (take @tag-bar-open-count other-details))
              (when (> (count other-details) @tag-bar-open-count)
                [c/interactive
                 :div {:style {:display :flex
                               :justify-content :center
                               :align-items :center
                               :cursor :pointer}
                       :on-click #(re/dispatch [:voice-insights/increase-tag-bar-open-count tag-name])}
                 [:span {:style {:font-size 12
                                 :line-height "18px"
                                 :font-weight style/font-regular-weight
                                 :color (style/color :blue :shade-1)}}
                  "View More"]])]))]))

(defn key-metrics-loading []
  [c/loader-rectangle {:height 420}])

(defn key-metrics [_]
  (let [crew-type- (re/subscribe [:core/selected-crew-type-])]
    (fn [data {:keys [location-metrics?] :or {location-metrics? false}}]
      (if (util/loading? data)
        [key-metrics-loading]
        (let [crew-type-tag-names-to-remove (if (= @crew-type- "ai")
                                              #{}
                                              #{:ai-outcome})]
          [alc/card {:title "Key Metrics"
                     :icon-type :CallIntentIcon
                     :subtitle "Percentage of sessions with the tag"
                     :style {:padding "16px 0"
                             :width "100%"}
                     :header-style {:padding "0 16px"}}
           [:div {:style {:display :flex
                          :flex-direction :column
                          :padding-top 6}}
            (into [:div]
                  (some->> (sort-by (fn [[tag _]]
                                      (vi.d/tag-sort-order tag))
                                    data)
                           (filterv (fn [t]
                                      (not (contains? (set/union #{:summary :intent-summary :improvement-recommendation
                                                                   :outcome}
                                                                 tag.d/key-metrics-hidden-tag-names
                                                                 crew-type-tag-names-to-remove)
                                                      (some-> t (first))))))
                           (mapv (fn [tags]
                                   [tag-bar tags {:location-metrics? location-metrics?}]))))]])))))